// Date validation utilities for birthdate inputs
export const DateValidation = {
  // Constants for validation
  MIN_BIRTH_YEAR: 1920,

  // Get today's date in YYYY-MM-DD format for HTML5 max attribute
  getTodayString: (): string => {
    return new Date().toISOString().split('T')[0];
  },

  // Get minimum date string for HTML5 min attribute
  getMinDateString: (): string => {
    return `${DateValidation.MIN_BIRTH_YEAR}-01-01`;
  },

  // Validation functions for React Hook Form
  validateNotTooOld: (value: string): string | true => {
    const date = new Date(value);
    const minDate = new Date(DateValidation.getMinDateString());
    return date >= minDate || "La data è troppo lontana nel passato";
  },

  validateNotFuture: (value: string): string | true => {
    const date = new Date(value);
    const today = new Date();
    // Set today to end of day for comparison
    today.setHours(23, 59, 59, 999);
    return date <= today || "Non puoi inserire una data futura";
  },

  validateAdultAge: (value: string): string | true => {
    const date = new Date(value);
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();

    // Adjust age if birthday hasn't occurred this year
    if (
      today.getMonth() < date.getMonth() ||
      (today.getMonth() === date.getMonth() && today.getDate() < date.getDate())
    ) {
      age--;
    }

    return age >= 18 || "Devi essere maggiorenne";
  },

  // Combined validation for adult accounts (EditAccount and Register)
  getAdultValidationRules: () => ({
    required: "Campo obbligatorio",
    validate: {
      notTooOld: DateValidation.validateNotTooOld,
      notFuture: DateValidation.validateNotFuture,
      adultAge: DateValidation.validateAdultAge,
    },
  }),

  // Validation for family members (can be children)
  getMemberValidationRules: () => ({
    required: "Campo obbligatorio",
    validate: {
      notTooOld: DateValidation.validateNotTooOld,
      notFuture: DateValidation.validateNotFuture,
    },
  }),
};